// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".QpGUIxHqdsznR6pKcC_Sh{\n    margin:3px;\n    background-color:rgb(248, 5, 5);\n    color:white;\n    font-weight: bold;\n}\n\n.efz_Ur-LuuN3ZrWBi-_55{\n    margin:3px;\n    background-color:#7fff00;\n    font-weight: bold;\n}\n\n._2x_8KlMQYKTiXMKAD01seI{\n    margin:3px;\n    background-color:#ff007f;\n    color:white;\n    font-weight: bold;\n}\n\n._3NS63Q6fN7SHFX16chJdDM {\n    background-color: '#69c0ff';\n    margin:5px;\n    text-align: center;\n}\n", ""]);
// Exports
exports.locals = {
	"cardSpace1": "QpGUIxHqdsznR6pKcC_Sh",
	"cardSpace2": "efz_Ur-LuuN3ZrWBi-_55",
	"cardSpace3": "_2x_8KlMQYKTiXMKAD01seI",
	"mainCardSpace": "_3NS63Q6fN7SHFX16chJdDM"
};
module.exports = exports;
